import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit {
  @Input() progress: number = 0;
  @Input() userName: string = 'Usuario';
  @Output() loadingComplete: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit() {
    this.startLoading();
  }

  startLoading() {
    const interval = setInterval(() => {
      if (this.progress < 100) {
        this.progress += 5;
      } else {
        clearInterval(interval);
        setTimeout(() => {
          this.loadingComplete.emit();
        }, 500);
      }
    }, 200);
  }
}
